import * as React from "react"
import {Row, Col} from 'react-bootstrap';
import PropTypes from "prop-types"
import ReactMarkdown from "react-markdown"
import CtaBackground from "./ctaBg"
import HubspotForm from 'react-hubspot-form'

const MarkdownContent = ({classes="", content, props}) => {
  return(
    <Row className={`${classes} single_content`}>
      <Col xs={12} lg={{span:10, offset:1}}>
        {content.map((block, i) => {
          if(block.strapi_component === 'text.list-2-columns')
          return (
            <div key={i} style={{
              padding:`${block.padding !== null ? block.padding.top : '80'}px ${block.padding !== null ? block.padding.right : '0'}px ${block.padding !== null ? block.padding.bottom : '0'}px ${block.padding !== null ? block.padding.left : '0'}px`, 
              margin:`${block.margin !== null ? block.margin.top : '0'}px ${block.margin !== null ? block.margin.right : '0'}px ${block.margin !== null ? block.margin.bottom : '0'}px ${block.margin !== null ? block.margin.left : '0'}px`,
              borderBottom: `${block.bordered_bottom === true ? '1px solid #b5b5b5' : 'none'}`
            }}>
              <Row className={`${block.list_type}-list`}>
                <ReactMarkdown>{block.content}</ReactMarkdown>
                <Col xs={12} md={6}>
                <ReactMarkdown>{block.list_left}</ReactMarkdown>
                </Col>
                <Col xs={12} md={6}>
                <ReactMarkdown>{block.list_right}</ReactMarkdown>
                </Col>
              </Row>
            </div>
          )
          else if(block.strapi_component === 'text.list')
          return (
            <div key={i} style={{
              padding:`${block.padding !== null ? block.padding.top : '80'}px ${block.padding !== null ? block.padding.right : '0'}px ${block.padding !== null ? block.padding.bottom : '0'}px ${block.padding !== null ? block.padding.left : '0'}px`, 
              margin:`${block.margin !== null ? block.margin.top : '0'}px ${block.margin !== null ? block.margin.right : '0'}px ${block.margin !== null ? block.margin.bottom : '0'}px ${block.margin !== null ? block.margin.left : '0'}px`,
              borderBottom: `${block.bordered_bottom === true ? '1px solid #b5b5b5' : 'none'}`
            }}>
              <div className={`${block.list_type}-list`}>
                <ReactMarkdown>{block.content}</ReactMarkdown>
                <ReactMarkdown>{block.list}</ReactMarkdown>
              </div>
            </div>
          )
          else if(block.strapi_component === 'text.quote')
          return (
            <div key={i} style={{
              padding:`${block.padding !== null ? block.padding.top : '80'}px ${block.padding !== null ? block.padding.right : '0'}px ${block.padding !== null ? block.padding.bottom : '0'}px ${block.padding !== null ? block.padding.left : '0'}px`, 
              margin:`${block.margin !== null ? block.margin.top : '0'}px ${block.margin !== null ? block.margin.right : '0'}px ${block.margin !== null ? block.margin.bottom : '0'}px ${block.margin !== null ? block.margin.left : '0'}px`,
              borderBottom: `${block.bordered_bottom === true ? '1px solid #b5b5b5' : 'none'}`
            }}>
             <Row className={`block-quote`}>
                <h3>{block.content}</h3>
              </Row>
            </div>
          )
          else if(block.strapi_component === 'cta.cta')
          return (
            <div key={i} className={`cta_background background__${block.background_color}`} style={{
              padding:`${block.padding !== null ? block.padding.top : '80'}px ${block.padding !== null ? block.padding.right : '0'}px ${block.padding !== null ? block.padding.bottom : '0'}px ${block.padding !== null ? block.padding.left : '0'}px`, 
              margin:`${block.margin !== null ? block.margin.top : '0'}px ${block.margin !== null ? block.margin.right : '0'}px ${block.margin !== null ? block.margin.bottom : '0'}px ${block.margin !== null ? block.margin.left : '0'}px`,
              borderBottom: `${block.bordered_bottom === true ? '1px solid #b5b5b5' : 'none'}`
            }}>
              <CtaBackground 
                title={block.title}
                intro={block.content}
                link={block.url}
                linkText={block.button_text}
                type={block.type}
              />
            </div>
          )
          else if(block.strapi_component === 'media.image')
          return (
            <div key={i} style={{
              padding:`${block.padding !== null ? block.padding.top : '80'}px ${block.padding !== null ? block.padding.right : '0'}px ${block.padding !== null ? block.padding.bottom : '0'}px ${block.padding !== null ? block.padding.left : '0'}px`, 
              margin:`${block.margin !== null ? block.margin.top : '0'}px ${block.margin !== null ? block.margin.right : '0'}px ${block.margin !== null ? block.margin.bottom : '0'}px ${block.margin !== null ? block.margin.left : '0'}px`,
              borderBottom: `${block.bordered_bottom === true ? '1px solid #b5b5b5' : 'none'}`
            }}>
              <Row className={`block-images d-flex flex-wrap align-items-center`}>
                {block.images.map((image, i) => {
                  return (
                    block.images.length >= 2 ? 
                    <img  key={i} src={`https://cms.loyall.co/${image.url}`} alt={image.alternativeText} style={{width: "50%"}} />
                    : <img  key={i} src={`https://cms.loyall.co/${image.url}`} alt={image.alternativeText} />
                  )
                })}
              </Row>
            </div>
          )
          else if(block.strapi_component === 'form.form')
          return (
            <div key={i} className="hs-form" style={{
              padding:`${block.padding !== null ? block.padding.top : '80'}px ${block.padding !== null ? block.padding.right : '0'}px ${block.padding !== null ? block.padding.bottom : '0'}px ${block.padding !== null ? block.padding.left : '0'}px`, 
              margin:`${block.margin !== null ? block.margin.top : '0'}px ${block.margin !== null ? block.margin.right : '0'}px ${block.margin !== null ? block.margin.bottom : '0'}px ${block.margin !== null ? block.margin.left : '0'}px`,
              borderBottom: `${block.bordered_bottom === true ? '1px solid #b5b5b5' : 'none'}`
            }}>
             <HubspotForm
                portalId='5195515'
                formId={block.form_id}
                onSubmit={() => console.log('Submit!')}
                onReady={(form) => console.log('Form ready!')}
                loading={<div>Loading...</div>}
              />
            </div>
          )
          else 
          return (
            <div key={i} style={{
              padding:`${block.padding !== null ? block.padding.top : '80'}px ${block.padding !== null ? block.padding.right : '0'}px ${block.padding !== null ? block.padding.bottom : '0'}px ${block.padding !== null ? block.padding.left : '0'}px`, 
              margin:`${block.margin !== null ? block.margin.top : '0'}px ${block.margin !== null ? block.margin.right : '0'}px ${block.margin !== null ? block.margin.bottom : '0'}px ${block.margin !== null ? block.margin.left : '0'}px`,
              borderBottom: `${block.bordered_bottom === true ? '1px solid #b5b5b5' : 'none'}`,
              textAlign: `${block.center_text === true ? 'center' : 'inherit'}`
            }}>
              <ReactMarkdown>{block.content}</ReactMarkdown>
            </div>
          )
        })}
      </Col>
    </Row>
  )
}

MarkdownContent.propTypes = {
  classes: PropTypes.string,
  content: PropTypes.array,
}

export default MarkdownContent